import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { ActiveSecurityContextStateService } from '@security/active-security/active-security-context.state-service';
import { TopNavigationLink } from '@app/app-layout/header/product-navigation/navigation-bar/navigation-bar';
import { FeatureFlagService, FeatureFlagsServiceInjectionToken } from '@feature-flags/feature-flag.service';
import { BehaviorSubject, take } from 'rxjs';
import { holidayAllowanceRoutes } from '@app/admin-hub/holiday-allowances/holiday-allowance-routes';
import { adminHubAbsenceRoutes } from '@app/admin-hub/absence/absence-routes';

@Component({
  selector: 'app-admin-hub-navigation',
  templateUrl: './admin-hub-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: []
})
export class AdminHubNavigationComponent {
  adminHubLinksBehaviorSubject: BehaviorSubject<TopNavigationLink[]> = new BehaviorSubject<TopNavigationLink[]>([]);
  adminHubLinks$ = this.adminHubLinksBehaviorSubject.asObservable();

  constructor(
    public activeSecurity: ActiveSecurityContextStateService,
    @Inject(FeatureFlagsServiceInjectionToken) public featureFlagService: FeatureFlagService
  ) {
    this.createAdminLinks();
  }

  createAdminLinks = () => {
    this.featureFlagService
      .getAllValues$()
      .pipe(take(1))
      .subscribe((featureFlags) => {
        const adminLinks: TopNavigationLink[] = [];

        if (!this.activeSecurity.hasOrganisationAuthorityTo('AccessAdminHub')) return;

        if (this.activeSecurity.hasOrganisationAuthorityToOneOf(['AccessAbsenceCalendar']))
          adminLinks.push({
            label: 'Calendar',
            route: adminHubAbsenceRoutes.calendar,
            feature: 'AdminHubCalendar'
          });

        if (this.activeSecurity.hasOrganisationAuthorityTo('EditEmployeeLeave')) {
          adminLinks.push({
            label: 'Manage Holidays',
            route: holidayAllowanceRoutes.manageHolidayAllowances,
            feature: 'HolidayAllowanceDashboard'
          });
        }

        this.adminHubLinksBehaviorSubject.next(adminLinks);
      });
  };
}
